import Prism from 'prismjs';
import React, {useLayoutEffect, useRef, useState} from 'react';

import {QuickStartIcon} from '../QuickStartIcon';
import {CodeCopyButton} from './CodeCopyButton';
import * as S from './CodeSnippet.styles';

type CodeSnippetProps = {
  showExpandCollapse?: boolean;
  codeSnippet: string;
  analyticsEvent: (data: any) => void;
  analyticsDefaultProperties: Record<string, any>;
};

export const CodeSnippet = ({
  showExpandCollapse,
  codeSnippet,
  analyticsEvent,
  analyticsDefaultProperties,
}: CodeSnippetProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const codeRef = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    if (codeRef.current != null) {
      Prism.highlightElement(codeRef.current);
    }
  }, [codeSnippet]);

  return (
    <S.CodeSnippetContainer
      $isExpanded={isExpanded}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}>
      {isHovering && (
        <CodeCopyButton
          copyContent={codeSnippet}
          analyticsEvent={analyticsEvent}
          analyticsDefaultProperties={analyticsDefaultProperties}
        />
      )}
      <S.CodeSnippet $isExpanded={isExpanded}>
        <S.PrismCodeHighlighting ref={codeRef} className="language-python">
          {codeSnippet}
        </S.PrismCodeHighlighting>
      </S.CodeSnippet>
      {showExpandCollapse && (
        <S.CodeSnippetExpandCollapse onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? (
            <>
              Show less <QuickStartIcon name="chevron-up" />
            </>
          ) : (
            <>
              Show more <QuickStartIcon name="chevron-down" />
            </>
          )}
        </S.CodeSnippetExpandCollapse>
      )}
    </S.CodeSnippetContainer>
  );
};
